import {
    FETCH_ALL_BUSINESS_SUCCESS, EDIT_BUSINESS, UPDATE_BUSINESS_SUCCESS, CREATE_BUSINESS_SUCCESS, DELETE_BUSINESS_SUCCESS,SET_BUSINESS,SET_ROLE,GET_BUSINESS_SUCCESS
} from "constants/businesses.constants";

const INIT_STATE = {
    businesses: [],
    business_roles:[],
    business: {
        id: 0,
        name: '',
        pack:0,
        no_on_emp:0,
        is_facotry:0,
        ctns:[],
        abl_users:[]
    }
};
export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case SET_ROLE: {
            let c = Object.assign({}, state.business);
            let s = Boolean(action.value)

            var str = "";
            if (c.role_ids !== undefined) {
                str = c.role_ids;
            }

            if (s) {
                if (str === "") {
                    str = "" + action.key;
                } else {
                    str = str + "," + action.key;
                }
            } else {
                str = c.role_ids.replace(new RegExp(action.key + ',?'), '');
            }
            c.role_ids = str
            return {
                ...state,
                business:c
            }
        }
        //set business
        case SET_BUSINESS: {
            let c = Object.assign({}, state.business);
            c[action.key] = action.value
            return {
                ...state,
                business: c
            }
        }
        case FETCH_ALL_BUSINESS_SUCCESS: {
            return {
                ...state,
                businesses: action.payload.data,
                pagination: action.payload.page
            }
        }

        case GET_BUSINESS_SUCCESS: {
            return {
                ...state,
                business:action.payload.data
            }
        }

        case UPDATE_BUSINESS_SUCCESS: {
            let foundIndex = state.businesses.findIndex(x => x.id === action.payload.data.id);
            let all = Object.assign([], state.businesses);
            let o =  action.payload.data
            all[foundIndex] = o
            return {
                ...state,
                businesses: all,
                business: o,
            }
        }

        case CREATE_BUSINESS_SUCCESS: {
            let all = Object.assign([], state.businesses);
            all.push(action.payload.data)
            return {
                ...state,
                businesses: all,
                business: INIT_STATE.business
            }
        }

        case DELETE_BUSINESS_SUCCESS: {
            let all = Object.assign([], state.businesses);
            let newArray = all.filter(function (c) {
                return c.id !== action.payload.id
            });
            return {
                ...state,
                businesses: newArray,
            }
        }

        case EDIT_BUSINESS: {
            let u = state.businesses.find(c => c.id === action.payload)
            let o = Object.assign({}, u)
        
            o.pack = o.pack.id
            o.abl_users = []
           // o.business_type_id = o.partner_type.id
            return {
                ...state,
                business: o
            }
        }

        

        
        default:
            return state;
    }
}